import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import VerificationToggleMetricComponent from 'webapp/components/verification/toggle/metric';

import type { Metric } from 'webapp/models-custom';

interface Args {
	metric: Metric;
}

export default class MetricDetailsSettingsAboutComponent extends Component<Args> {
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;

	get showAboutLink(): boolean {
		const metric = this.args.metric;
		return (
			!!metric.description &&
			!metric.isTypeMetricCalculationGeneric &&
			!metric.isTypeMetricCalculationOrGeneric
		);
	}

	@action
	openExtraInfoPopup(): void {
		this.mmMetricsService.openExtraInfoPopup(this.args.metric);
	}

	<template>
		<div class="metric-details-verification-toggle">
			<VerificationToggleMetricComponent @metric={{@metric}} />
		</div>
		{{#if @metric.description}}
			<div class="block-metric-info">
				<div class="info">
					<span class="metric-details-section-label">Description</span>
					<p class="desc">{{@metric.description}}</p>
					{{#if this.showAboutLink}}
						<div class="more-info">
							<a
								role="button"
								class="more-info-link"
								{{on "click" this.openExtraInfoPopup}}
							>
								<CommonUiIconComponent @name="Book" @size="sm" />
								More about this metric
								<CommonUiIconComponent @name="External" @size="sm" />
							</a>
						</div>
					{{/if}}
				</div>
			</div>
		{{/if}}
	</template>
}
